export enum SignalRAlarmType {
    ANPR = 0,
    AHCR = 1,
    SpeedViolation = 2,
}